import React from 'react';

export const SeoRating: React.FC = () => {
  const ratingJson = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Бренды Лемана ПРО',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      reviewCount: '100',
    },
  };
  return <script type="application/ld+json">{JSON.stringify(ratingJson)}</script>;
};
